module.exports = __webpack_public_path__ + "img/sixpackcarrier57.538a87a8.jpg";